import React, { useCallback, useState, useEffect } from 'react';
import productService from '../services/productService';
import statsService from '../services/statsService';
import slugService from '../services/slugService';
import ProductCard from '../components/ProductCard';
import PageGrid from '../components/PageGrid';
import Sidebar from '../components/Sidebar';
import SidebarSection from '../components/Sidebar/SidebarSection';
import SidebarRow from '../components/Sidebar/SidebarRow';
import usePageTitle from '../utils/usePageTitle';
import { getTradingCardSetsBreadcrumbs } from '../utils/breadcrumbUtils';
import { filterProducts } from '../utils/filters';
import './TradingCardSetsPage.css';

/**
 * Trading Card Sets Page that uses the generic PageGrid component
 */
const TradingCardSetsPage = () => {
  // Set page title
  usePageTitle('Trading Card Sets');
  
  const [stats, setStats] = useState({
    totalProducts: 0,
    totalInsertSets: 0,
    totalCards: 0,
    lastUpdated: new Date()
  });
  const [statsLoaded, setStatsLoaded] = useState(false);
  
  // Load global stats when component mounts
  useEffect(() => {
    const loadStats = async () => {
      try {
        const globalStats = await statsService.getGlobalStats();
        setStats(globalStats);
        setStatsLoaded(true);
      } catch (error) {
        console.error('Error loading global stats:', error);
      }
    };
    
    loadStats();
  }, []);

  // Function to fetch products for a specific page
  const fetchProducts = useCallback(async (page, limit) => {
    try {
      const response = await productService.getProductsByPage(page, limit);
      
      return {
        items: response.products,
        currentPage: response.currentPage,
        totalPages: response.totalPages,
        totalItems: response.totalProducts
      };
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  }, []);
  
  
  // Function to render each product card
  const renderProductCard = useCallback((product, index) => {
    return (
      <ProductCard 
        product={product}
        index={index}
        linkPath={slugService.getTradingCardSetUrl(product)}
      />
    );
  }, []);

  // Render the sidebar content
  const renderSidebar = useCallback(() => {
    // if(!statsLoaded) {
    //   return <></>;
    // }
    return (
      <Sidebar title="Collection Statistics">
        {statsLoaded && (
          <SidebarSection>
            <SidebarRow 
              label="Total Trading Card Sets" 
              value={stats.totalProducts.toLocaleString()} 
            />
            <SidebarRow 
              label="Total Insert Sets" 
              value={stats.totalInsertSets.toLocaleString()} 
            />
            <SidebarRow 
              label="Total Cards" 
              value={stats.totalCards.toLocaleString()} 
            />
            <SidebarRow 
              label="Last Updated" 
              value={new Date(stats.lastUpdated).toLocaleDateString()} 
            />
          </SidebarSection>
        )}
      </Sidebar>
    );
  }, [stats]);

  // Generate breadcrumb items for trading card sets page
  const breadcrumbItems = getTradingCardSetsBreadcrumbs();

  return (
    <PageGrid
      title="Trading Card Sets"
      fetchItems={fetchProducts}
      renderItem={renderProductCard}
      renderSidebar={renderSidebar}
      filterFunction={filterProducts}
      placeholderText="Filter trading card sets..."
      emptyStateMessage="No trading card sets found"
      itemsPerPage={100}
      breadcrumbItems={breadcrumbItems}
    />
  );
};

export default TradingCardSetsPage;